import React from 'react';
import {useLocation} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { headerShowPanel } from '../../redux/actions/Sidebar';
import { isHeaderVisible } from '../../redux/selector/Sidebar';
import {
  StyledNavLink,
  StyledLinksContainer,
  StyledReactTooltip,
  StyledNavContainer,
  StyledTabsInfo,
} from './styled';

export default function PageSideBarNavigation({ links }) {
  const tabsRef = React.useRef(null);
  const {pathname} = useLocation();
  React.useEffect(() => {
    const tabs = tabsRef.current;
    const active = tabs?.querySelector('.active-button');
    if (!tabs || !active) return;
    const outer = tabs.getBoundingClientRect(), inner = active.getBoundingClientRect();
    if (inner.left < outer.left) tabs.scrollLeft += inner.left - outer.left;
    else if (inner.right > outer.right) tabs.scrollLeft += inner.right - outer.right;
  }, [pathname]);
  // REDUX
  const dispatch = useDispatch();
  const showHeader = useSelector(isHeaderVisible);
  React.useEffect(() => {
    if (!showHeader) {
      dispatch(headerShowPanel(true));
    }
  }, [dispatch, showHeader]);
  // REDUX
  return (
    <StyledLinksContainer ref={tabsRef}>
      {links.map(
        ({ to, text, isDisabled, showTooltip, tooltipContent = '' }, index) =>
          showTooltip ? (
            <StyledNavContainer key={text}>
              <StyledNavLink
                disabled={isDisabled}
                key={index}
                to={to}
                activeClassName="active-button"
              >
                <StyledReactTooltip
                  id={to}
                  type="light"
                  effect="solid"
                  place="bottom"
                >
                  {tooltipContent}
                </StyledReactTooltip>
                {text}
                <StyledTabsInfo
                  iconsize="10"
                  data-tip
                  clickable="true"
                  data-for={to}
                />
              </StyledNavLink>
            </StyledNavContainer>
          ) : (
            <StyledNavContainer
              className={text.replace(/ /g, '-').toLowerCase()}
              key={text}
            >
              <StyledNavLink
                disabled={isDisabled}
                key={index}
                to={to}
                activeClassName="active-button"
              >
                {text}
              </StyledNavLink>
            </StyledNavContainer>
          )
      )}
    </StyledLinksContainer>
  );
}
